import { gql } from '@apollo/client';
import * as React from 'react';
import { Accept, useDropzone } from 'react-dropzone';
import { useSignUrlLazyQuery } from 'types/gqlReactTypings.generated.d';

interface Props {
  onSuccess?: (fileUrl: string, fileName: string, fileKey: string) => void;
  accept?: Accept;
  maxFiles?: number;
}

gql`
  query SignUrl($objectName: String!, $contentType: String!) {
    signUrl(objectName: $objectName, contentType: $contentType) {
      signedUrl, publicUrl, fileName, fileKey
    }
  }
`

export const FileDropzone: React.FC<Props> = ({ accept, maxFiles = 1, onSuccess }: Props) => {
  const [useSignUrl] = useSignUrlLazyQuery({});

  const { acceptedFiles, getRootProps, getInputProps, } = useDropzone({
    maxFiles,
    multiple: maxFiles > 1,
    accept: accept,
  });

  React.useEffect(() => {
    if (acceptedFiles.length === 0) {
      return;
    }

    const uploadFiles = async () => {
      for (const file of acceptedFiles) {
        try {
          const res = await useSignUrl({
            variables: { objectName: file.name, contentType: file.type },
          });
          if (res.data == null) {
            console.error("Signed data does not exist");
            continue;
          }

          const { signedUrl, publicUrl, fileName, fileKey } = res.data.signUrl;
          await fetch(signedUrl, {
            method: "PUT",
            body: file,
            headers: {
              'Content-Type': file.type,
            },
          });
          onSuccess?.(publicUrl, fileName, fileKey);
        } catch (error) {
          console.error(error);
        }
      }
    };

    uploadFiles();
  }, [acceptedFiles]);

  return (
    <section className="container">
      <div {...getRootProps({ className: 'dropzone' })} style={{ border: '1px dashed #888', borderRadius: 10, padding: 20 }}>
        <input {...getInputProps()} />
        <p>Drag 'n' drop or add file</p>
      </div>
    </section>
  );
}
